import { render, staticRenderFns } from "./newsDetail.vue?vue&type=template&id=15bc4901&scoped=true"
import script from "./newsDetail.vue?vue&type=script&lang=js"
export * from "./newsDetail.vue?vue&type=script&lang=js"
import style0 from "./newsDetail.vue?vue&type=style&index=0&id=15bc4901&prod&scoped=true&lang=less"
import style1 from "./newsDetail.vue?vue&type=style&index=1&id=15bc4901&prod&lang=less&scoped=true"
import style2 from "./newsDetail.vue?vue&type=style&index=2&id=15bc4901&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bc4901",
  null
  
)

export default component.exports